// import Vue from 'vue'
// import Vuex from 'vuex'

// Vue.use(Vuex)
import { createStore } from 'vuex'

export const store = createStore({
    state(){
       return { 
        UrlReportServer: "https://reportserver.cdiyucatan.mx/ReportServer?/SITE/",        
        UrlServiciosAdmin: "https://wcfadmin.cdiyucatan.mx/",
        UrlServicios: "https://wcfsite.cdiyucatan.mx/",
        UrlServiciosInventario: "https://wcfinventario.cdiyucatan.mx/",        
        UrlFrontAdmin: "https://frontadmin.cdiyucatan.mx/",
        loading: false,
        usuario: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')) : null,
        version: '2.13'
       }
    },
    mutations:{
        setLoading(state,bool){
            state.loading = bool;
        },
        setUsuarioLogueado(state,user){
            state.usuario = user;
            localStorage.setItem('user', JSON.stringify(user),7200000);
        },
    },
    actions:{
        setLoading({commit},bool){
            commit("setLoading",bool);
        },
        setUsuarioLogueado({commit},user){
            commit("setUsuarioLogueado",user);
        },
    },
    getters:{
        getVersion: (state) => {
            return state.version
        },
        getUrlReportes: (state) => {
            return state.UrlReportServer
        },
        getUrlServicios: (state) => {
            return state.UrlServicios
        },
        getUrlServiciosAdmin: (state) => {
            return state.UrlServiciosAdmin
        },
        getUrlServiciosInventario: (state) => {
            return state.UrlServiciosInventario
        },
        getLoading: (state) => {
            return state.loading
        },
        getUsuarioLogueado: (state) => {
            return state.usuario
        },
        getUrlFrontAdmin: (state) => {
            return state.UrlFrontAdmin
        },
    },
    modules:{

    }
})